export function getElementOffset ( el )
{
    if ( typeof el === 'string' )
    {
        el = document.querySelector( el );
    }

    const rect       = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop  = window.pageYOffset || document.documentElement.scrollTop;

    return { top : rect.top + scrollTop, left : rect.left + scrollLeft }
}


export function getCheckedValueFromRadioGroup (  elements )
{

    const checked = Array.from(elements).find( input => input.checked );

    return checked ? checked.value : '';

}
